"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Composite = _interopRequireDefault(require("./renderer/Composite.js"));

var _PluggableMap = _interopRequireDefault(require("./PluggableMap.js"));

var _obj = require("./obj.js");

var _control = require("./control.js");

var _interaction = require("./interaction.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var __extends = void 0 && (void 0).__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
/**
 * @module ol/Map
 */


/**
 * @classdesc
 * The map is the core component of OpenLayers. For a map to render, a view,
 * one or more layers, and a target container are needed:
 *
 *     import Map from 'ol/Map';
 *     import View from 'ol/View';
 *     import TileLayer from 'ol/layer/Tile';
 *     import OSM from 'ol/source/OSM';
 *
 *     var map = new Map({
 *       view: new View({
 *         center: [0, 0],
 *         zoom: 1
 *       }),
 *       layers: [
 *         new TileLayer({
 *           source: new OSM()
 *         })
 *       ],
 *       target: 'map'
 *     });
 *
 * The above snippet creates a map using a {@link module:ol/layer/Tile~TileLayer} to
 * display {@link module:ol/source/OSM~OSM} OSM data and render it to a DOM
 * element with the id `map`.
 *
 * The constructor places a viewport container (with CSS class name
 * `ol-viewport`) in the target element (see `getViewport()`), and then two
 * further elements within the viewport: one with CSS class name
 * `ol-overlaycontainer-stopevent` for controls and some overlays, and one with
 * CSS class name `ol-overlaycontainer` for other overlays (see the `stopEvent`
 * option of {@link module:ol/Overlay~Overlay} for the difference). The map
 * itself is placed in a further element within the viewport.
 *
 * Layers are stored as a {@link module:ol/Collection~Collection} in
 * layerGroups. A top-level group is provided by the library. This is what is
 * accessed by `getLayerGroup` and `setLayerGroup`. Layers entered in the
 * options are added to this group, and `addLayer` and `removeLayer` change the
 * layer collection in the group. `getLayers` is a convenience function for
 * `getLayerGroup().getLayers()`. Note that {@link module:ol/layer/Group~LayerGroup}
 * is a subclass of {@link module:ol/layer/Base~BaseLayer}, so layers entered in the
 * options or added with `addLayer` can be groups, which can contain further
 * groups, and so on.
 *
 * @api
 */
var Map =
/** @class */
function (_super) {
  __extends(Map, _super);
  /**
   * @param {import("./PluggableMap.js").MapOptions} options Map options.
   */


  function Map(options) {
    options = (0, _obj.assign)({}, options);

    if (!options.controls) {
      options.controls = (0, _control.defaults)();
    }

    if (!options.interactions) {
      options.interactions = (0, _interaction.defaults)({
        onFocusOnly: true
      });
    }

    return _super.call(this, options) || this;
  }

  Map.prototype.createRenderer = function () {
    return new _Composite["default"](this);
  };

  return Map;
}(_PluggableMap["default"]);

var _default = Map;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUdBOztBQUNBOztBQUNBOztBQUNBOztBQUNBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBUEE7Ozs7O0FBU0E7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBK0NBO0FBQUE7QUFBQTtFQUFrQkE7RUFDaEI7Ozs7O0VBR0EsYUFBWUMsT0FBWixFQUFtQjtJQUNqQkEsT0FBTyxHQUFHLGlCQUFPLEVBQVAsRUFBV0EsT0FBWCxDQUFWOztJQUNBLElBQUksQ0FBQ0EsT0FBTyxDQUFDQyxRQUFiLEVBQXVCO01BQ3JCRCxPQUFPLENBQUNDLFFBQVIsR0FBbUIsd0JBQW5CO0lBQ0Q7O0lBQ0QsSUFBSSxDQUFDRCxPQUFPLENBQUNFLFlBQWIsRUFBMkI7TUFDekJGLE9BQU8sQ0FBQ0UsWUFBUixHQUF1QiwyQkFBb0I7UUFDekNDLFdBQVcsRUFBRTtNQUQ0QixDQUFwQixDQUF2QjtJQUdEOztXQUVEQyxrQkFBTUosT0FBTixLQUFjO0VBQ2Y7O0VBRURLO0lBQ0UsT0FBTyxJQUFJQyxxQkFBSixDQUF5QixJQUF6QixDQUFQO0VBQ0QsQ0FGRDs7RUFHRjtBQUFDLENBckJELENBQWtCQyx3QkFBbEI7O2VBdUJlRixHIiwibmFtZXMiOlsiX19leHRlbmRzIiwib3B0aW9ucyIsImNvbnRyb2xzIiwiaW50ZXJhY3Rpb25zIiwib25Gb2N1c09ubHkiLCJfc3VwZXIiLCJNYXAiLCJDb21wb3NpdGVNYXBSZW5kZXJlciIsIlBsdWdnYWJsZU1hcCJdLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJzcmMvTWFwLmpzIl0sInNvdXJjZXNDb250ZW50IjpbbnVsbF19